const state = {
  recentSearch: [],
}

const mutations = {
  setRecentSearch(state, searchWord) {
    state.recentSearch = searchWord
  },
}

const getters = {
  recentSearch(state) {
    return state.recentSearch
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
